'use client';

// src/app/global-error.tsx
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error:', error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Error - JuicyStarz</title>
        <style>{`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            background: #0a0a0a;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            padding: 1rem;
          }
          .container {
            text-align: center;
            max-width: 600px;
          }
          .icon {
            width: 80px;
            height: 80px;
            margin: 0 auto 2rem;
            background: rgba(239, 68, 68, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .icon svg {
            width: 40px;
            height: 40px;
            color: #ef4444;
          }
          h1 {
            font-size: 2.5rem;
            margin-bottom: 1rem;
            color: #ef4444;
          }
          h2 {
            font-size: 1.875rem;
            margin-bottom: 1rem;
            font-weight: 600;
          }
          p {
            font-size: 1.125rem;
            color: #a0a0a0;
            margin-bottom: 2rem;
            line-height: 1.6;
          }
          .buttons {
            display: flex;
            gap: 1rem;
            justify-content: center;
            flex-wrap: wrap;
          }
          button, a {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.875rem 1.5rem;
            font-size: 1rem;
            font-weight: 500;
            border-radius: 0.5rem;
            cursor: pointer;
            transition: all 0.2s;
            text-decoration: none;
            border: none;
          }
          .primary {
            background: #8b5cf6;
            color: white;
          }
          .primary:hover {
            background: #7c3aed;
          }
          .secondary {
            background: #1f1f1f;
            color: white;
          }
          .secondary:hover {
            background: #2a2a2a;
          }
          .digest {
            margin-top: 2rem;
            font-size: 0.75rem;
            color: #666;
            font-family: 'Courier New', monospace;
          }
        `}</style>
      </head>
      <body>
        <div className="container">
          <div className="icon">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <h1>500</h1>
          <h2>Critical Error</h2>
          <p>
            We&apos;re experiencing a critical system error. Our team has been automatically notified and is working on a fix.
          </p>

          <div className="buttons">
            <button onClick={reset} className="primary">
              Try Again
            </button>
            <a href="/" className="secondary">
              Go Home
            </a>
          </div>

          {error.digest && (
            <p className="digest">Error ID: {error.digest}</p>
          )}
        </div>
      </body>
    </html>
  );
}
